<template>
  <div class="guide-item">
    <div class="guide-title" @click="toggleOpen">
      <div class="text">{{title}}</div>
      <div v-if="!isOpen" class="action">展开<span class="arrow"></span></div>
      <div v-else class="action opened">收起<span class="arrow"></span></div>
    </div>
    <div class="guide-content" v-show="isOpen">
      <div v-html="content"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GuideItem',
  props: {
    title: String,
    openDefault: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      isOpen: this.$props.openDefault
    }
  },
  methods: {
    toggleOpen(){
      this.isOpen = !this.isOpen;
      this.isOpen && this.$emit('opened', this.title);
    }
  }
}
</script>
<style lang="less">
  .guide-item{
    margin:.15rem .0;
    padding:.30rem;
    border-radius: .12rem;
    background: #F4F5F5;
    .text,.action{
      display: inline-block;
      vertical-align: middle;
      height:.60rem;
      line-height: .60rem;
      &.text{
        width: 80%;
        text-align: left;
        font-size:.28rem;
        font-weight: 500;
        color: #1E1E1E;
      }
      &.action{
        width: 15%;
        text-align: right;
        font-size:.24rem;
        color:#999;
        .arrow{
           display: inline-block;
           margin-left: .05rem;
           width:.32rem;
           height: .18rem;
           background: url("../common/img/ico/ico-arrow-down.png") no-repeat center;
           background-size: .32rem .18rem;
           opacity: .3;
        }
        &.opened .arrow{
          transform: rotate(180deg);
        }
      }
    }
    .guide-content{
      font-size: .24rem;
      line-height: .34rem;
      color: #4d4d4d;
    }
    .c-red{
      color:red;
    }
    .c-blue{
      color:#09c;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/orderList/GuideItem.vue